import { render } from "./NotificationComponent.vue?vue&type=template&id=48921bae&scoped=true&ts=true"
import script from "./NotificationComponent.vue?vue&type=script&lang=ts"
export * from "./NotificationComponent.vue?vue&type=script&lang=ts"

import "./NotificationComponent.vue?vue&type=style&index=0&id=48921bae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48921bae"]])

export default __exports__